import { SideMenuItem } from '../SideMenuItem';
import { Menu, Wrapper } from './styles';
import AuditoriaModule from '@/modules/Auditoria';
import EntradasModule from '@/modules/Entradas';
import ExpedicoesModule from '@/modules/Expedicoes';
import MovimentacoesModule from '@/modules/Movimentacoes';
import PainelModule from '@/modules/Painel';
import LogoutModule from '@/modules/Logout'
import { ModuleFakeErp } from '@/modules/FakeRp';
import ModuleRelatorio from '@/modules/Relatorio';
import { useState } from 'react';
import ModuleAtualizacao from '@/modules/Atualizacoes';
import ModuleAbastecimento from '@/modules/Abastecimento';
import { usePermition } from '@/hooks/usePermition';
import { IconType } from 'react-icons';

export const menuItems: {
  to: string;
  title: string;
  icon: IconType;
  id: number;
  childrens?: {
    to?: string;
    title: string;
    fullTitle?: string;
    id?: number;
    childrens?: {
      to: string;
      title: string;
      fullTitle?: string;
      id?: number;
    }[];
  }[]
}[] = [
    PainelModule.menuItem,
    ModuleRelatorio.menuItem,
    EntradasModule.menuItem,
    MovimentacoesModule.menuItem,
    ExpedicoesModule.menuItem,
    AuditoriaModule.menuItem,
    ModuleAbastecimento.menuItem,
    ModuleFakeErp.menuItem,
    ModuleAtualizacao.menuItem,
    LogoutModule.menuItem
  ];

export function SideMenu() {
  const [isActive, setIsActive] = useState<number>();
  const { menus } = usePermition();

  return (
    <Wrapper>
      <Menu>
        {menus?.map((item, index) => {
          return (
            <SideMenuItem
              key={index}
              isOpen={index === isActive}
              setIsOpen={() => setIsActive(v => v === index ? undefined : index)}
              {...item}
            />
          );
        })}
      </Menu>
    </Wrapper>
  );
}

